import { graphql } from '../../../gql';

export const GET_PLATFORM_SENTIMENT_MAP_QUERY = graphql(`
  query getPlatformSentimentMap {
    platformSentimentMap {
      nRegions
      nStories
      computedAt
      regions {
        level
        path
        sentiment
        nReplies
        nNegative
        nNeutral
        nPositive
        stories {
          storyId
          title
          score
          sentiment
          nReplies
        }
      }
    }
  }
`);
